import React from "react";
import PageHeader from "../components/PageHeader";

export default function Constitution() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Pages", link: "/pages" },
    { label: " Functions & Powers ", active: true },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader title="कार्य एवं शक्तियाँ" breadcrumbs={breadcrumbs} />

          {/* National Commission Section */}
      <div className="container-fluid bg-light py-5 mt-5 border-top">
        <div className="container wow fadeInUp" data-wow-delay="0.2s">
          <div className="text-center mb-5">
            <h2 className="display-6 fw-semibold">
              कार्य एवं शक्तियाँ 
            </h2>
          </div>

          <div className="row g-5">

  {/* LEFT COLUMN */}
  <div className="col-lg-6">
    <div className="p-4 bg-white rounded-4 shadow-sm h-100">

      <p>
        बाल अधिकारों पर कन्वेंशन के अनुपालन का मूल्यांकन करने के लिए विद्यमान
        विधि नीति और प्रथा का विश्लेषण करना।
      </p>

      <p>
        शिशुओं को प्रभावित करने वाली प्रथा या नीति के किसी पहलू की जाँच पड़ताल
        करना तथा प्रतिवेदन प्रस्तुत करना और बाल अधिकारों के परिप्रेक्ष्य में
        प्रस्तावित नये विधान पर मंतव्य देना।
      </p>

      <p>
        बाल अधिकारों के संरक्षण से संबंधित रक्षोपाय के कार्य प्रणाली पर राज्य
        सरकार को वार्षिक और ऐसे अनन्य अन्तरालों पर प्रतिवेदन प्रस्तुत करना जैसा
        कि आयोग उचित समझे।
      </p>

      <p>
        हाशिए पर रहने वाले तथा संवेदनशील परिस्थितियों में ग्रस्त बच्चों पर ध्यान
        केंद्रित करते हुए विशिष्ट कार्यक्रमों और प्रयासों का संचालन करना।
      </p>

      <p>
        बाल अधिकारों के संरक्षण, राष्ट्रीय आयोग के साथ समन्वय करना तथा
        अंतरंगता स्थापित करना।
      </p>

      <p>
        आयोग ऐसे मुद्दे पर विचार नहीं करेगा या उसकी जाँच पड़ताल नहीं करेगा जो
        राष्ट्रीय बाल अधिकार संरक्षण आयोग या तत्समय प्रवृत किसी विधि के अधीन
        गठित किसी अन्य आयोग के विचाराधीन हों।
      </p>

      <p>
        जहाँ स्वयं शिशुओं द्वारा या उनकी ओर से संबद्ध व्यक्ति की चिन्ता व्यक्त
        की गई हो वहाँ औपचारिक जाँच-पड़ताल करना।
      </p>

      <p>
        बाल अधिकारों से संबंधित कार्यक्रमों के लिए आवश्यक दिशा-निर्देश,
        प्रोटोकॉल और पारदर्शिता निर्धारित करके अभिशासन प्रक्रिया को बच्चों
        के प्रति जवाबदेह बनाना।
      </p>

    </div>
  </div>

  {/* RIGHT COLUMN */}
  <div className="col-lg-6">
    <div className="p-4  rounded-4 shadow-sm h-100">

      <ul className="mb-0 custom-list">
        <li>
          बाल अधिकारों को सभी स्थानीय निकायों, संबंधित विभागों और समाज की
          विकास कार्यसूची के केंद्र में लाना।
        </li>

        <li>
          परिवारों, समुदायों तथा बच्चों की देखभाल व संरक्षण के लिए जिम्मेदार
          अन्य एजेंसियों व निकायों का सुदृढ़ीकरण करना।
        </li>

        <li>
          बाल अधिकारों के उल्लंघनों की शिकायतों की जाँच पड़ताल करते समय आयोग
          राज्य सरकार या अन्य प्राधिकार से सूचना या प्रतिवेदन की मांग कर सकेगा।
        </li>

        <li>
          यदि आयोग का समाधान हो जाए कि आगे किसी जाँच की आवश्यकता नहीं है तो
          शिकायतकर्ता को सूचित करना।
        </li>

        <li>
          यह सुनिश्चित करना कि आयोग के कार्य शिशुओं के प्रत्यक्षतः सूचित
          विचारों पर आधारित हों।
        </li>

        <li>
          बच्चों से संबंधित सभी सरकारी विभागों और संगठनों में बच्चों के
          विचारों को प्रोत्साहित करना।
        </li>

        <li>
          बच्चों से संबंधित आंकड़े संकलित एवं उनका विश्लेषण करना।
        </li>

        <li>
          बाल अधिकारों के बारे में जानकारी विकसित करना और उनका प्रचार-प्रसार
          करना जिसमें वेबसाइट बनाना भी शामिल है।
        </li>

        <li>
          विद्यालय पाठ्यक्रम, शिक्षक प्रशिक्षण, पुलिस एवं सरकारी पदाधिकारियों
          के प्रशिक्षण में बाल अधिकारों का समावेशन।
        </li>
      </ul>

    </div>
  </div>

</div>

        </div>
      </div>
    </div>
  );
}
